import { useEffect, useState } from "react";
import axios from "axios";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS as STATIC_TESTIMONIALS } from "../lib/site";
import { SITE } from "../lib/site";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Testimonials() {
  const [items, setItems] = useState(STATIC_TESTIMONIALS);
  useEffect(() => {
    axios
      .get(`${API}/testimonials`)
      .then((res) => {
        if (res.data && res.data.length > 0) setItems(res.data);
      })
      .catch(() => {});
  }, []);
  const TESTIMONIALS = items;
  return (
    <section
      id="avis"
      data-testid="testimonials-section"
      className="py-24 md:py-32 bg-gradient-to-b from-transparent to-[#E8F5E9]/40"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <div className="text-sm tracking-[0.25em] uppercase text-[#1B5E20] font-medium mb-4">
            Avis Google
          </div>
          <h2 className="font-['Outfit'] text-4xl sm:text-5xl font-light tracking-tight text-[#1A2E1C] leading-tight">
            La confiance de{" "}
            <span className="text-[#1B5E20] font-medium">nos clients</span>
          </h2>
          <div className="mt-6 inline-flex items-center gap-3 px-5 py-2 rounded-full bg-white border border-[#E5EBE5] shadow-sm">
            <div className="flex gap-0.5">
              {[...Array(5)].map((_, j) => (
                <Star
                  key={`star-header-${j}`}
                  className="w-4 h-4 fill-[#FBBC04] text-[#FBBC04]"
                />
              ))}
            </div>
            <span className="text-sm font-medium text-[#1A2E1C]">
              5,0/5 sur Google
            </span>
            <span className="text-sm text-[#5C705E]">· 25 avis</span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {TESTIMONIALS.map((t, i) => (
            <div
              key={t.name}
              data-testid={`testimonial-${i}`}
              className="bg-white rounded-3xl p-7 border border-[#E5EBE5] hover:shadow-xl transition-all duration-300 flex flex-col"
            >
              <div className="flex items-center justify-between mb-4">
                <Quote className="w-8 h-8 text-[#A5D6A7]" />
                <div className="flex gap-1">
                  {[...Array(5)].map((_, j) => (
                    <Star
                      key={`star-${t.name}-${j}`}
                      className="w-4 h-4 fill-[#FBBC04] text-[#FBBC04]"
                    />
                  ))}
                </div>
              </div>
              <p className="text-[#1A2E1C] leading-relaxed flex-1">
                « {t.text} »
              </p>
              <div className="mt-5 pt-5 border-t border-[#E5EBE5] flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-[#1B5E20] text-white flex items-center justify-center font-['Outfit'] font-semibold">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <div className="font-['Outfit'] font-semibold text-[#1A2E1C]">
                    {t.name}
                  </div>
                  <div className="text-xs text-[#5C705E]">
                    Avis vérifié Google
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Google Maps live embed */}
        <div className="bg-white rounded-3xl p-6 md:p-8 border border-[#E5EBE5] shadow-sm">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-5">
            <div>
              <h3 className="font-['Outfit'] font-semibold text-[#1A2E1C] text-lg">
                Retrouvez-nous sur Google
              </h3>
              <p className="text-sm text-[#5C705E]">
                Avis en temps réel mis à jour automatiquement
              </p>
            </div>
            <div className="flex flex-wrap gap-2">
            <a
              href={SITE.googleReview}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="see-all-google-reviews"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-white border border-[#E5EBE5] rounded-full text-[#1A2E1C] text-sm font-medium hover:bg-[#E8F5E9] hover:border-[#1B5E20] transition-all"
            >
              <svg viewBox="0 0 24 24" className="w-4 h-4" aria-hidden="true">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09Z" />
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.99.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A10.99 10.99 0 0 0 12 23Z" />
                <path fill="#FBBC05" d="M5.84 14.1A6.61 6.61 0 0 1 5.5 12c0-.73.13-1.44.34-2.1V7.07H2.18A11 11 0 0 0 1 12c0 1.77.42 3.45 1.18 4.93l3.66-2.83Z" />
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.46 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.83C6.71 7.3 9.14 5.38 12 5.38Z" />
              </svg>
              Voir tous les avis Google
            </a>
            <a
              href={SITE.googleWriteReview}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="leave-google-review"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-[#1B5E20] rounded-full text-white text-sm font-medium hover:bg-[#164d1a] transition-colors"
            >
              <Star className="w-4 h-4 fill-[#FBBC04] text-[#FBBC04]" />
              Laisser un avis
            </a>
            </div>
          </div>
          <div className="rounded-2xl overflow-hidden border border-[#E5EBE5]">
            <iframe
              src="https://maps.google.com/maps?q=K%27reuse+Exterieur+La+Celle-Dunoise&t=&z=11&ie=UTF8&iwloc=&output=embed"
              width="100%"
              height="380"
              style={{ border: 0 }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="K'REUSE EXTÉRIEUR — Localisation et avis Google"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
